import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary" | "ghost";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: Variant;
}

const VARIANT_CLASSES: Record<Variant, string> = {
  primary:
    "bg-primary text-on-solid hover:bg-primary-hover active:bg-primary-active disabled:bg-primary-disabled",
  secondary:
    "bg-surface text-ink border border-line-strong hover:bg-surface-2 active:bg-surface-3 disabled:opacity-50",
  ghost: "bg-transparent text-ink-3 hover:bg-surface-3 disabled:opacity-50",
};

export function Button({ variant = "primary", className = "", ...rest }: ButtonProps) {
  return (
    <button
      className={`inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-focus focus-visible:ring-offset-2 focus-visible:ring-offset-surface ${VARIANT_CLASSES[variant]} ${className}`}
      {...rest}
    />
  );
}
